import { ReactNativeLDClient } from '@launchdarkly/react-native-client-sdk'
import { LDClient } from 'launchdarkly-react-client-sdk'
import { includes } from 'lodash-es'

import { MULTIPLE_PRIMARY_NEEDS_ORIGINS } from './searchForCareExperimentTypes'
import { ExperimentPayload, MultiplePrimaryNeedsArmMapping } from './types'
import { generateMultiplePrimaryNeedsExperimentPayload } from './utils'
import { LD_CUSTOM_EVENTS } from '../common/constants/constants'
import { CustomerName } from '../common/constants/customer'

const customerExlusions = [CustomerName.STARBUCKS]

export type SendMultiplePrimaryNeedsExperimentDataParams = {
  canSelectMultiplePrimaryNeeds?: boolean
  userId: string
  searchId?: string | null
  deviceUUID?: string
  customerName?: string
  postExperimentEntrypoint?: (payload: ExperimentPayload) => void
  ldClient?: LDClient | ReactNativeLDClient
  isLyraSelect?: boolean
  origin: MULTIPLE_PRIMARY_NEEDS_ORIGINS
}

/**
 * Standalone function to send multiple primary needs experiment data.
 * This function can be used independently of hooks for cases like homebase tracking.
 **/

export const sendMultiplePrimaryNeedsExperimentData = ({
  canSelectMultiplePrimaryNeeds,
  userId,
  searchId,
  deviceUUID,
  customerName,
  postExperimentEntrypoint,
  ldClient,
  isLyraSelect,
  origin,
}: SendMultiplePrimaryNeedsExperimentDataParams) => {
  const shouldSendData =
    deviceUUID && postExperimentEntrypoint && !isLyraSelect && !includes(customerExlusions, customerName)

  if (shouldSendData) {
    try {
      const experimentPayload = generateMultiplePrimaryNeedsExperimentPayload({
        arm: canSelectMultiplePrimaryNeeds
          ? MultiplePrimaryNeedsArmMapping.EXPERIMENT
          : MultiplePrimaryNeedsArmMapping.CONTROL,
        client_lyra_id: userId,
        search_id: searchId,
        device_uuid: deviceUUID,
        customer_name: customerName,
        origin,
      })
      postExperimentEntrypoint(experimentPayload)

      ldClient?.track(LD_CUSTOM_EVENTS.PRIMARY_NEEDS_VIEWED, {
        search_id: searchId,
      })
    } catch (e) {
      console.error('Unable to post multiple primary needs experiment data', e)
    }
  }
}
